/**
 * SecureEmbed Energy Portal - TierBadge Component
 */

import React from 'react';
import { TIERS } from '../constants/tiers';

interface TierBadgeProps {
  tier: number;
  size?: 'sm' | 'md';
}

const TierBadge: React.FC<TierBadgeProps> = ({ tier, size = 'sm' }) => {
  const def = TIERS[tier];
  if (!def) return null;

  const sizeClasses = size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs';

  return (
    <span className={`inline-flex items-center rounded font-semibold ${def.bgColor} ${def.color} ${sizeClasses}`}>
      {def.shortLabel}
    </span>
  );
};

export default TierBadge;
